import React, { useEffect, useState } from "react";
import DashboardCard from "./components/DashboardCard";
import UpcommingTable from "./components/UpcommingTable";
import DoctorAppointment from "./components/DoctorAppointment";
import baseUrl from "../../api/baseUrl";
import EventNoteIcon from "@mui/icons-material/EventNote";
import GroupIcon from "@mui/icons-material/Group";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import UniquePatientChart from "./components/UniquePatientChart";
import TreatmentPieChart from "./components/TreatmentPieChart";

function Dashboard() {
  const [count, setcount] = useState({
    patients: 0,
    lastmonthPatients: 0,
    registerToday: 0,
    appointmentToday: 0,
    appointmentTomorrow: 0,
    cancelledToday: 0,
    cancelledthismonth: 0,
    waittingForConsultant: 0,
    totalTreatments: 0,
    lastmonthAppointment: 0,
  });

  useEffect(() => {
    baseUrl
      .get("dashboard/findPatientsCount")
      .then((response) => {
        setcount((prev) => ({
          ...prev,
          patients: response.data.count,
          lastmonthPatients: response.data.lastmonthRegister,
          registerToday: response.data.todayRegister,
          appointmentToday: response.data.appointmentToday,
          appointmentTomorrow: response.data.appointmentTomorrow,
          cancelledToday: response.data.cancelledToday,
          cancelledthismonth: response.data.cancelledthismonth,
          waittingForConsultant: response.data.waittingForConsultant,
          totalTreatments: response.data.totalTreatments,
          lastmonthAppointment: response.data.lastmonthAppointment,
        }));
      })
      .catch((error) => {
        console.error(error.response);
      });
  }, []);

  const DASHBOARD_HOME = [
    {
      name: "Last Month Appointments",
      det: count?.lastmonthAppointment,
      icon: EventNoteIcon,
      color: "amber",
      gradient: "from-amber-400 to-orange-500",
    },
    {
      name: "Total Patients",
      det: count.patients,
      icon: GroupIcon,
      color: "purple",
      gradient: "from-purple-400 to-pink-500",
    },
    {
      name: "Last Month Treatments",
      det: count.totalTreatments,
      icon: MedicalServicesIcon,
      color: "indigo",
      gradient: "from-indigo-400 to-blue-500",
    },
  ];

  return (
    <div className="space-y-6 text-slate-800 dark:text-slate-200">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {DASHBOARD_HOME?.map((item, i) => (
          <DashboardCard
            key={i}
            name={item?.name}
            det={item?.det}
            Icon={item?.icon}
            gradient={item?.gradient}
          />
        ))}
      </div>

      {/* Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <UniquePatientChart />
        <TreatmentPieChart />
      </div>

      {/* Tables */}
      <UpcommingTable />
      <DoctorAppointment />
    </div>
  );
}

export default Dashboard;
